import { Typography } from "components/parts/Typography/Typography";
import { newColors } from "constants/newColors";
import React from "react";
import { NotificationEvent } from "types/graphqlapi";
import { getDisplayYMD, getDisplayYMDhm } from "utils/common";
import {
  StyledInterview,
  StyledInterviewList,
  StyledInterviewTitle,
  StyledInterviewSeq,
  StyledNotificationEvent,
  StyledNotificationEventTitle,
  StyledTriangleRight,
} from "./styled";
import { DisplayInterviewWithNotificationEvent } from "pages/MailHistoryManagement/hook";

type InterviewListProps = {
  interviewList: DisplayInterviewWithNotificationEvent[];
  selectedNotificationEvent: NotificationEvent | undefined;
  selectNotificationEvent: (
    notificationEvent: NotificationEvent | undefined
  ) => void;
};

export const NotificationEventList: React.FC<InterviewListProps> = ({
  interviewList,
  selectedNotificationEvent,
  selectNotificationEvent,
}) => {
  const [openInterviewIdList, setOpenInterviewIdList] = React.useState<
    string[]
  >([]);

  const toggleInterview = (interviewId: string) => {
    setOpenInterviewIdList((prev) => {
      if (prev.includes(interviewId)) {
        return prev.filter((id) => id !== interviewId);
      } else {
        return [...prev, interviewId];
      }
    });
  };

  return (
    <>
      <StyledInterviewList>
        {interviewList &&
          interviewList.map((interview) => (
            <>
              <StyledInterview
                key={interview.id}
                onClick={() => {
                  toggleInterview(interview.id);
                }}
              >
                <StyledTriangleRight
                  style={
                    openInterviewIdList.includes(interview.id)
                      ? { transform: "rotate(90deg)" }
                      : {}
                  }
                />
                <StyledInterviewSeq
                  text={`${interview.interview_seq}`}
                  textAlign="left"
                />
                <StyledInterviewTitle>
                  <Typography
                    text={`${
                      interview.scheduled_start_date &&
                      interview.scheduled_end_date
                        ? `${getDisplayYMD(
                            new Date(interview.scheduled_start_date)
                          )} ${
                            interview.scheduled_start_time
                          } ～ ${getDisplayYMD(
                            new Date(interview.scheduled_end_date)
                          )} ${interview.scheduled_end_time} （${
                            interview.notificationEventList.length
                          }件）`
                        : ""
                    }`}
                  />
                </StyledInterviewTitle>
              </StyledInterview>
              {openInterviewIdList.includes(interview.id) &&
                interview.notificationEventList.length > 0 &&
                interview.notificationEventList.map((notificationEvent) => (
                  <StyledNotificationEvent
                    key={notificationEvent.id}
                    onClick={() => {
                      selectNotificationEvent(notificationEvent);
                    }}
                    style={
                      selectedNotificationEvent?.id === notificationEvent.id
                        ? { background: newColors.selected, cursor: "default" }
                        : {}
                    }
                  >
                    <StyledNotificationEventTitle>
                      <Typography
                        text={getDisplayYMDhm(
                          new Date(notificationEvent.createdAt)
                        )}
                      />
                      <Typography
                        text={
                          notificationEvent.notification_event_type ===
                          "MENTION"
                            ? "メンション"
                            : notificationEvent.notification_event_type ===
                              "ANNOUNCE"
                            ? "アナウンス通知"
                            : ""
                        }
                      />
                    </StyledNotificationEventTitle>
                  </StyledNotificationEvent>
                ))}
            </>
          ))}
      </StyledInterviewList>
    </>
  );
};
